module.exports = __webpack_public_path__ + "img/arrow_profile.763b6bf2.png";